<template>
  <div>
    <charges-calculator />
  </div>
</template>

<script>
import ChargesCalculator from '@/components/resources/ChargesCalculator'
export default {
  components: {
    ChargesCalculator
  },
  mounted() {
    this.$mpTrack('Charges calculator page')
  }
}
</script>
